import * as actions from "./actionTypes";
import axios from '../../axios_call';
import { BASE_URL, getCurrentLoginUserId } from "../../components/Helpers/helpers";

const roleListStart = () => {
    return {
        type : actions.ROLE_LIST_START
    }
}

const roleListFail = (error) => {
    return {
        type : actions.ROLE_LIST_FAIL,
        error : error
    }   
}

const roleListSuccess = (message,data,page) => {
    return {
        type : actions.ROLE_LIST_SUCCESS,
        message : message,
        data : data,
        page : page
    }
}

const roleDeleteAction = (id) => {
    return {
        type : actions.ROLE_DELETE,
        id : id,
    }
}

const roleAddEditStart = () => {
    return {
        type : actions.ROLE_ADD_EDIT_START
    }
}

const roleAddEditFail = (error) => {
    return {
        type : actions.ROLE_ADD_EDIT_FAIL,
        error : error,
        redirectTo:null
    }   
}

const roleAddEditSuccess = (message,data) => {
    return {
        type : actions.ROLE_ADD_EDIT_SUCCESS,
        message : message,
        data : data,
        redirectTo:"/roles"
    }
}

const addEditRoleSuccessMessage = (message) => {
    return {
        type : actions.ROLE_ADD_EDIT_SUCCESS_MESSAGE,
        message : message,
    }
}

const rolefilterList = (text) => {
    return {
        type : actions.ROLE_LIST_FILTER,
        text : text,
    }
}


export const roleDetail = (data,error) => {
    return {
      type: actions.ROLE_DETAIL,
      data: data,
      error: error,
    };
}

export const roleStateList = (data,error) => {
    return {
        type : actions.ROLE_STATE_LIST,
        data : data,
        error : error,
    }
}

const moduleListAction = (message,data,page) => {
    return {
        type : actions.MODULE_LIST,
        message : message,
        data : data,
        page : page
    }
}

const addEditStart = () => ({
  type: actions.ROLE_ADD_EDIT_START,
});

const addEditFail = (error) => ({
  type: actions.ROLE_ADD_EDIT_FAIL,
  error,
});

const addEditSuccess = (message, data) => ({
  type: actions.ROLE_ADD_EDIT_SUCCESS,
  message,
  data,
});

export const roleCountryList = (data,error) => {
    return {
        type : actions.ROLE_COUNTRY_LIST,
        data : data,
        error : error,
    }
}

export const roleList = (param) => {
    return (dispatch) => {
        dispatch(roleListStart());
        axios
          .get("role")
          .then((response) => {
            if (response.data.status === 200) {
              const data = response.data.data;
              const msg = response.data.message;
              dispatch(roleListSuccess(msg, data));
            } else {
              dispatch(roleListFail(response.data.message));
            }
          })
          .catch((error) => {
            dispatch(roleListFail(error.message));
          });
      };
}

export const moduleList = () => {
    return (dispatch) => {
      axios
      .get("/module")
      .then((response) => {
        if (response.data.status === 200) {
          dispatch(moduleListAction("", response.data.data));
        } else {
          dispatch(moduleListAction("No module found!", null ));
        }
      }).catch((error) => {
        dispatch(moduleListAction("Failed to fetch modules", null ));
      });
    };
  };

  export const roleDelete = (id, navigate) => {
    return (dispatch) => {        
        axios.delete(`role/delete/${id}`, {
     
      currentUserId: getCurrentLoginUserId(),
    
  })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch(roleDeleteAction(id));
                navigate('/roles');
            }           
        })
        .catch((error) => {
            console.error("Error deleting role:", error);
        });
    };
};


export const getRoleDetail = (id) => {
  return (dispatch) => {
    axios
      .get(`role/get-role/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          dispatch(roleDetail(response.data.data, ""));
        } else {
          dispatch(roleDetail(null, "Invalid Role Detail"));
        }
      })
      .catch((error) => {
        dispatch(roleDetail(null, "Error fetching role details"));
      });
  };
};

export const roleAddEdit = (param, navigate) => {
    return dispatch => {        
        dispatch(roleAddEditStart());
        axios.post('role',param)
        .then((response) => {
            if(response.data.status) {
                const data = response.data.result
                const msg = response.data.message 
                dispatch(roleAddEditSuccess(msg,data));
                navigate('/roles');
            } else {
                dispatch(roleAddEditFail(response.data.message))
            }            
        })
        .catch((error) => {
            dispatch(roleAddEditFail(error.message))
        })
    }
}

export const addEditRole = (params) => {
    return (dispatch) => {
      dispatch(addEditStart());
  
      const processedParams = {
        ...params,
        action_permission: Array.isArray(params.action_permission)
          ? params.action_permission.join("~")
          : params.action_permission,
        permission: Array.isArray(params.permission)
          ? params.permission.join("~")
          : params.permission,
      };
  
      axios
        .post(`${BASE_URL}/role`, processedParams)
        .then((response) => {
          if (response.status) {
            const data = response.data;
            const message = response.data.message;
            dispatch(addEditSuccess(message, data));
          } else {
            dispatch(addEditFail("Failed to add role."));
          }
        })
        .catch((error) => {
          const errorMessage = error.response?.data?.message || "An error occurred.";
          dispatch(addEditFail(errorMessage));
        });
    };
  };

export const addEditRoleSuccessNull = () => (dispatch) => {
  dispatch(addEditRoleSuccessMessage(null));
};

export const EditRole = (id) => {
    return (dispatch) => {
      dispatch(addEditStart());
      if (typeof id !== 'string' && typeof id !== 'number') {
        dispatch(addEditFail("Invalid ID"));
        return;
      }
  
      axios
        .post(`${BASE_URL}/role/update/${id}`,{currentUserId:getCurrentLoginUserId()})
        .then((response) => {
          if (response.status) { 
            const data = response.data;
            const message = response.data.message;
            dispatch(addEditSuccess(message, data));
          } else {
            dispatch(addEditFail("Failed to update role."));
          }
        })
        .catch((error) => {
          dispatch(addEditFail(error.response?.data?.message || "An error occurred."));
        });
    };
  };

export const roleListFilter = (filterText) => {
    return dispatch => {        
        dispatch(rolefilterList(filterText));
    }
}